import { CommonModule } from '@angular/common';
import { Component, HostListener, Input, OnChanges, computed, inject, input, output, signal } from '@angular/core';
import { EVENT_SCHEMA, EventTrackerInternalService } from '@app/services/event-tracker-2.service';
import { EventTrackerService, QiraEventHumanReadable } from '@app/services/event-tracker.service';
import { ChatTab } from '@app/services/types';
import { VehicleService } from '@app/services/vehicle.service';
import { CloseTabButtonComponent } from '../close-tab-button/close-tab-button.component';

@Component({
  selector: 'app-tab-button',
  imports: [CloseTabButtonComponent, CommonModule],
  templateUrl: './tab-button.component.html',
  standalone: true,
  styleUrl: './tab-button.component.scss',
})
export class TabButtonComponent implements OnChanges {
  @Input() contentClass: string | undefined;
  @Input() hideCloseButton = false;
  tab = input<ChatTab | undefined>();
  darkMode = input(false);
  onTabClosed = output<void>();

  vehicleService = inject(VehicleService);
  eventTrackerService = inject(EventTrackerService);
  eventTrackerInternal = inject(EventTrackerInternalService);

  vehicle = computed(() => this.tab()?.session.vehicle);

  fuelTypesString = signal<string | undefined>(undefined);

  cssClass = computed(() => {
    const classes = [];
    classes.push(this.darkMode() ? 'text-stone-100 hover:text-white' : 'text-black');
    if (this.contentClass) {
      classes.push(this.contentClass);
    }
    return classes;
  });

  async ngOnChanges() {
    const fuelsString = await this.vehicleService.getFuelsString(this.vehicle()?.fuelType);
    this.fuelTypesString.set(fuelsString);
  }

  @HostListener('click')
  onClick() {
    if (this.tab()) {
      // deprecated event tracking
      this.eventTrackerService.logEvent(QiraEventHumanReadable.USER_CLICK_THREAD_TAB, {
        thread_id: this.tab()?._id,
      });

      this.eventTrackerInternal.trackEvent(EVENT_SCHEMA.CORE_PRODUCT.UI.THREAD_TAB_CLICKED, {
        thread_id: this.tab()?._id,
      });
    }
  }

  onTabClose() {
    this.onTabClosed.emit();
  }
}
